<template>
  <v-container :fluid="true" class="header__container">
    <v-row justify="start" class="header__content" no-gutters v-if="$vuetify.display.width >= 1280">
      <v-col align-self="center" cols="4">
        <v-img
            :width="$vuetify.display.width > 1560 ? 320 : 220"
            :src="logo_black"
            aspect-ratio="1/1"
            :cover="true"
            alt="logo_black"
        />
      </v-col>
      <v-col align-self="end" cols="4">
        <v-img
            :src="header_img"
            :width="$vuetify.display.width > 1560 ? 270 : 180"
            aspect-ratio="1/1"
            :cover="true"
            alt="header_logo"
        />
      </v-col>
      <div class="header__circle" v-if="$vuetify.display.width >= 1280">
        <v-img
            :src="big_blue_circle"
            :width="$vuetify.display.width > 1560 ? 300 : 220"
            aspect-ratio="1/1"
            :cover="true"
            alt="header_logo"
        />
      </div>
    </v-row>
    <v-row no-gutters justify="center" class="mobile__container" v-else>
      <v-col cols="12" align-self="center" class="mobile__logo">
        <v-img
            :src="mobile_logo_registration"
            :width="160"
            aspect-ratio="1/1"
            :cover="true"
            alt="header_logo"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import logo_black from "@/assets/img/logo_black.svg"
import header_img from "@/assets/img/header_logo.png"
import big_blue_circle from "@/assets/img/big_blue_circle.svg"
import mobile_logo_registration from "@/assets/img/mobile_logo_registration.svg"

export default defineComponent({
  name: "CoreHeader",
  data () {
    return {
      logo_black: logo_black,
      header_img: header_img,
      big_blue_circle: big_blue_circle,
      mobile_logo_registration: mobile_logo_registration,
    }
  }
})
</script>

<style scoped lang="scss">
.header__container {
  position: relative;
  z-index: 1000;
  padding: 0 0 0 240px;
  height: 220px;
  border-bottom: 1px solid #3254B9;
}

.header__content {
  height: 220px;
  position: relative;
}

.header__circle {
  align-self: end;
  position: absolute;
  right: 0;
  top: 0;
}

.mobile__container {
  height: 90px;
  background: #313743;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.4);
}

.mobile__logo {
  display: inline-grid;
  justify-content: center;
}

@media screen and (max-width: 1920px) {
  .header__container {
    height: 200px;
  }

  .header__content {
    height: 200px;
  }

  .header__circle {
    right: 0;
    top: 0;
  }
}

@media screen and (max-width: 1560px) {
  .header__container {
    height: 150px;
  }

  .header__content {
    height: 150px;
  }
}

@media screen and (max-width: 1279px) {
  .header__container {
    height: 90px;
    border-bottom: none;
    padding: 0;
  }
}
</style>
